import {Link} from 'react-router-dom';

function Header() {
  return (
    <div className="flex justify-between text-xl border-b border-[#ddd] py-5 px-10 md:px-30">
        <Link to="/">
          <div className="font-bold"> Repo<span className="text-[#754efa]">Findr</span></div>
        </Link>
        <Link to="/resources">
          <div className="font-bold text-[#754efa]"> Recources </div>
        </Link>
    </div>
  );
}

export default Header;
